export const getWriteupType = (data: any) => {
  const hasFS = !!data.financialData;
  const hasBank = !!data.bankStatementFindings;
  const hasCreditReport = !!data.selectedCreditReportItems;
  const hasCorp = !!data.accountData;

  // Full Analysis
  if (hasFS && hasBank && hasCreditReport && hasCorp) {
    return {
      templateType: 'full_analysis',
      templateDescription: 'Comprehensive Credit Analysis',
    };
  }

  // FS Only
  if (hasFS && !hasBank && !hasCreditReport && !hasCorp) {
    const isInterim = data.summaryPreferences?.financialStatementType === 'interim_fs';
    return {
      templateType: isInterim ? 'interim_fs' : 'fye_accountant',
      templateDescription: isInterim ? 'Interim Financial Analysis' : 'FYE Accountant-Prepared Report',
    };
  }

  // Bank Only
  if (hasBank && !hasFS && !hasCreditReport && !hasCorp) {
    return {
      templateType: 'bank_statements',
      templateDescription: 'Bank Statement Analysis',
    };
  }

  // Combined (FS + Bank)
  if (hasFS && hasBank) {
    return {
      templateType: 'combined_financial_analysis',
      templateDescription: 'Integrated Cash Flow & Financial Report',
    };
  }

  // Default Fallback
  return {
    templateType: 'custom_credit_writeup',
    templateDescription: 'Credit Analysis',
  };
};